import React from 'react';
import PropTypes from 'prop-types';
import SplitterLayout from 'react-splitter-layout';

const Splitter = props => (
  <SplitterLayout
    primaryMinSize={10}
    secondaryMinSize={10}
    onSecondaryPaneSizeChange={props.onChange}
  >
    <div />
    <div />
  </SplitterLayout>
);

Splitter.propTypes = {
  onChange: PropTypes.func.isRequired
};

export default Splitter;



// WEBPACK FOOTER //
// ./src/component/Splitter.js